import gql from 'graphql-tag';

export const PresenceSettingsQuery = gql`
	query PresenceSettingsQuery($cloudId: ID!, $spaceKey: String!) {
		confluence_teamPresenceContentSetting(cloudId: $cloudId, spaceKey: $spaceKey) {
			isEnabledOnContentView
		}
	}
`;
